import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import RecordingOverview from './recording-overview/RecordingOverview';
import Transcription from './transcription/Transcription';
import { ContentBlock, TwoColumnLayout } from './Content.style';
import useRecordingDetail from '../hooks/useRecordingDetail';
import useAudioPlayer from '../hooks/useAudioPlayer';
import { getDisplayPhones } from '../utils/getDisplayPhones';
import isAudioExpired from '../utils/isAudioExpired';

const Content = (): ReactElement => {
  const { id } = useParams<{ id: string }>();
  const recordingId = Number(id);
  const [messageApi, contextHolder] = message.useMessage();
  const { recording, advisors, customers, updateSummary, updateRecording } = useRecordingDetail(
    recordingId,
    messageApi
  );
  // 文字起こしの time_code からプレイヤーを操作するため、プレイヤーと文字起こしの共通の親で保持する
  const audioPlayer = useAudioPlayer({
    recordingId,
    duration: recording.duration,
    presignedUrl: recording.presignedUrl,
  });
  const isAudioAvailable = !isAudioExpired(recording.registeredAt);

  const displayPhones = useMemo(
    () =>
      getDisplayPhones({
        advisor: recording.advisor,
        customer: recording.customer,
        originalFrom: recording.originalFrom,
        originalTo: recording.originalTo,
      }),
    [recording.advisor, recording.customer, recording.originalFrom, recording.originalTo]
  );

  return (
    <ContentBlock>
      {contextHolder}
      <TwoColumnLayout>
        <RecordingOverview
          title={recording.title}
          advisor={recording.advisor}
          customer={recording.customer}
          meetingDateTime={recording.meetingDateTime}
          advisors={advisors}
          customers={customers}
          advisorPhone={displayPhones.advisorPhone}
          customerPhone={displayPhones.customerPhone}
          originalFrom={recording.originalFrom}
          originalTo={recording.originalTo}
          duration={recording.duration}
          registeredAt={recording.registeredAt}
          isAudioAvailable={isAudioAvailable}
          audioPlayer={audioPlayer}
          summaryText={recording.summaryText}
          recordingStatusId={recording.recordingStatusId}
          onUpdateRecording={updateRecording}
          onUpdateSummary={updateSummary}
        />
        <Transcription
          fullText={recording.fullText}
          recordingStatusId={recording.recordingStatusId}
          title={recording.title}
          advisorName={recording.advisor?.name ?? null}
          customerName={recording.customer?.name ?? null}
          advisorPhone={displayPhones.advisorPhone}
          customerPhone={displayPhones.customerPhone}
          onTimeCodeClick={isAudioAvailable ? audioPlayer.seekToSeconds : null}
        />
      </TwoColumnLayout>
    </ContentBlock>
  );
};

export default Content;
